import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import PageNextJs from 'nextjs/PageNextJs';

const Terms = dynamic(() => import('ui/pages/Terms'), { ssr: false });

const Page: NextPage = () => {
  return (
    <PageNextJs pathname="/terms">
      <Terms/>
    </PageNextJs>
  );
};

export default Page;
